import { useRef } from "react";
import ReactMultiCarousel from "react-multi-carousel";

import "react-multi-carousel/lib/styles.css";
import styles from "./styles.module.scss";
import { Box as MantineBox, Image as MantineImage } from "@mantine/core";

const responsive = {
  all: {
    breakpoint: { max: 10000, min: 0 },
    items: 1,
  },
};

type Props = {
  images?: Array<string | null | undefined>;
  infinite?: boolean;
};
const Carousel = ({ images, infinite = false }: Props) => {
  const carouselRef = useRef<ReactMultiCarousel>(null);

  return (
    <MantineBox className={styles.carousel}>
      <ReactMultiCarousel responsive={responsive} draggable ref={carouselRef} infinite={infinite}>
        {images?.map(
          (image, index) =>
            image && (
              <MantineBox key={`${image}-${index}`}>
                <MantineImage
                  src={image}
                  alt={`carousel-${index}`}
                  loading={index === 0 ? "eager" : "lazy"}
                  onError={(e) => {
                    e.currentTarget.src = "/kurb_broken_image.svg";
                    e.currentTarget.dataset.broken = "true";
                  }}
                />
              </MantineBox>
            )
        )}
      </ReactMultiCarousel>
    </MantineBox>
  );
};

export default Carousel;
